// Sort education/experience entries newest-first.
// "Newest" = highest end_date, with current/null end_date treated as the newest possible
function _toComparable(d) {
  if (!d) return Number.POSITIVE_INFINITY; // empty/current = newest
  const t = new Date(d).getTime();
  return isNaN(t) ? 0 : t;
}

export function sortByLatest(items, endField = 'end_date', startField = 'start_date') {
  if (!Array.isArray(items)) return items;
  return [...items].sort((a, b) => {
    const aEnd = _toComparable(a?.[endField]);
    const bEnd = _toComparable(b?.[endField]);
    if (bEnd !== aEnd) return bEnd - aEnd;
    return _toComparable(b?.[startField]) - _toComparable(a?.[startField]);
  });
}
